import * as React from 'react';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';
import './TeamMembers.css';
import HtmlFormater from 'src/utils/htmlFormaterUtil';

export interface ProjectTeamMemberCardComponentProps {
  teamMember: ProjectTeamMember;
  profilePicture?: File;
}

const ProjectTeamMemberCardComponent: React.StatelessComponent<ProjectTeamMemberCardComponentProps> =
  (props: ProjectTeamMemberCardComponentProps) => (
    <div
      className="row Aligner Aligner-extra"
    >
      <div className="col-md-4">
        <img
          className="fit-image"
          alt={props.teamMember.fullName}
          src={props.profilePicture ?
            // tslint:disable-next-line:no-any
            (window.URL || (window as any).webkitURL).createObjectURL(props.profilePicture) :
            '/img/user-profile-big.png'
          }
        />
      </div>
      <div className="col-md-8" style={{left: ' 30px'}}>
        <div className="row">
          <div className="teamName">
            {props.teamMember.fullName},
          </div>
        </div>
        <div className="row deco-title">
          <div className="jobTitle">
            {props.teamMember.jobTitle}
          </div>
        </div>
        <div className="row" style={{marginBottom: '15px'}}>
          <div
            className="from-rich-editor descript"
            dangerouslySetInnerHTML={{__html: HtmlFormater.parseMarkDownImages(props.teamMember.description)}}
          />
        </div>
        <div className="row">
          <a href={props.teamMember.linkedinProfile}>
            <img src="/img/in.png" style={{width: '30px', height: '30px'}}/>
          </a>

        </div>
      </div>
    </div>
  );

export default ProjectTeamMemberCardComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/team-members/ProjectTeamMemberCard.component.tsx